import { Divider, theme } from "antd";
import { Content } from "antd/es/layout/layout";
import React from "react";

const SaleInfoSection = ({ title, extra, minHeight = 280, margin = "30px 0 0 0", children }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Content
      style={{
        padding: 24,
        margin,
        minHeight,
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}
    >
      <div className="container-subtitle">
        <h3 className="subtitle-page">{title}</h3>
        {extra}
      </div>
      <Divider />
      {children}
    </Content>
  );
};

export default SaleInfoSection;
